export default "__VITE_ASSET__bb798376__"